// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inspections {
  cursor: pointer;
}
.inspections ion-icon {
  margin-top: 15px;
  text-align: center;
  font-size: 1.3em;
  width: 100%;
}
.inspections .inspectionRow {
  min-height: 100px;
}
.inspections .inspectionRow.departure {
  border-left: solid 12px var(--ion-color-departure);
}
.inspections .inspectionRow.return {
  border-left: solid 12px var(--ion-color-return);
}
.inspections .inspectionRow.intermediate {
  border-left: solid 12px var(--ion-color-intermediate);
}
.inspections ion-grid {
  padding: 5px 10px 5px 10px;
}
.inspections ion-grid ion-row {
  padding: 5px 0 5px 0;
}

.fields-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.fields-wrapper .field {
  margin: 2px;
}
.fields-wrapper .field .label {
  font-size: smaller;
  font-style: italic;
}
.fields-wrapper .field .value {
  font-size: medium;
  font-weight: bold;
}

.disabled {
  opacity: 0.8;
}

.error {
  color: var(--ion-color-danger);
}

.warning {
  color: var(--ion-color-orange);
}

.hidden {
  opacity: 0;
  height: 0;
  min-height: 0;
}

.deliveries {
  cursor: pointer;
}
.deliveries .ltcRow {
  min-height: 100px;
}
.deliveries .ltcRow.mine {
  border-left: solid 12px var(--ion-color-first-category);
}
.deliveries .ltcRow.not-mine {
  border-left: solid 12px var(--ion-color-third-category);
}`, "",{"version":3,"sources":["webpack://./src/app/components/card.component.scss","webpack://./src/app/components/delivery-card-skeleton/delivery-card-skeleton.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;ACCJ;ADCI;EACI,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;ACCR;ADEI;EACI,iBAAA;ACAR;ADEQ;EACI,kDAAA;ACAZ;ADGQ;EACI,+CAAA;ACDZ;ADIQ;EACI,qDAAA;ACFZ;ADMI;EACI,0BAAA;ACJR;ADMQ;EACI,oBAAA;ACJZ;;ADSA;EACI,aAAA;EACA,8BAAA;ACNJ;ADQI;EACI,WAAA;ACNR;ADQQ;EACI,kBAAA;EACA,kBAAA;ACNZ;ADSQ;EACI,iBAAA;EACA,iBAAA;ACPZ;;ADYA;EACI,YAAA;ACTJ;;ADYA;EACI,8BAAA;ACTJ;;ADYA;EACI,8BAAA;ACTJ;;ADYA;EACI,UAAA;EACA,SAAA;EACA,aAAA;ACTJ;;AA1DA;EACI,eAAA;AA6DJ;AA3DI;EACI,iBAAA;AA6DR;AA3DQ;EACI,uDAAA;AA6DZ;AA1DQ;EACI,uDAAA;AA4DZ","sourcesContent":[".inspections {\r\n    cursor: pointer;\r\n\r\n    ion-icon {\r\n        margin-top: 15px;\r\n        text-align: center;\r\n        font-size: 1.3em;\r\n        width: 100%;\r\n    }\r\n\r\n    .inspectionRow {\r\n        min-height: 100px;\r\n\r\n        &.departure {\r\n            border-left: solid 12px var(--ion-color-departure);\r\n        }\r\n\r\n        &.return {\r\n            border-left: solid 12px var(--ion-color-return);\r\n        }\r\n\r\n        &.intermediate {\r\n            border-left: solid 12px var(--ion-color-intermediate);\r\n        }\r\n    }\r\n\r\n    ion-grid {\r\n        padding: 5px 10px 5px 10px;\r\n\r\n        ion-row {\r\n            padding: 5px 0 5px 0;\r\n        }\r\n    }\r\n}\r\n\r\n.fields-wrapper {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n\r\n    .field {\r\n        margin: 2px;\r\n\r\n        .label {\r\n            font-size: smaller;\r\n            font-style: italic;\r\n        }\r\n\r\n        .value {\r\n            font-size: medium;\r\n            font-weight: bold;\r\n        }\r\n    }\r\n}\r\n\r\n.disabled {\r\n    opacity: 0.8;\r\n}\r\n\r\n.error {\r\n    color: var(--ion-color-danger);\r\n}\r\n\r\n.warning {\r\n    color: var(--ion-color-orange);\r\n}\r\n\r\n.hidden {\r\n    opacity: 0;\r\n    height: 0;\r\n    min-height: 0;\r\n}\r\n","@import '../card.component';\r\n\r\n.deliveries {\r\n    cursor: pointer;\r\n\r\n    .ltcRow {\r\n        min-height: 100px;\r\n\r\n        &.mine {\r\n            border-left: solid 12px var(--ion-color-first-category);\r\n        }\r\n\r\n        &.not-mine {\r\n            border-left: solid 12px var(--ion-color-third-category);\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
